import { createContext } from 'react';

const LangContext = createContext('en');

export default LangContext;